import 'react';
import styled from 'styled-components';
import CheckIcon from './CheckIcon.js';
import Spacer from './Spacer.js';
import { jsxs, jsx } from 'react/jsx-runtime';
function Checkbox({
  onChange,
  disabled,
  checked,
  children
}) {
  // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop
  const handleClick = () => {
    onChange(!checked);
  };
  return /*#__PURE__*/jsxs(Container, {
    children: [/*#__PURE__*/jsxs(Box, {
      disabled: disabled,
      checked: checked,
      children: [checked && /*#__PURE__*/jsx(CheckIcon, {}), /*#__PURE__*/jsx(Input, {
        type: "checkbox",
        checked: checked,
        onClick: disabled ? undefined : handleClick,
        disabled: disabled
      })]
    }), /*#__PURE__*/jsx(Spacer, {
      size: "xs",
      vertical: true
    }), children]
  });
}
const Input = styled.input`
  position: absolute;
  appearance: none;
  ${({
  disabled
}) => disabled ? '' : 'cursor: pointer;'};
  width: 100%;
  height: 100%;
  margin: 0;
`;
const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const Box = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({
  theme,
  checked
}) => checked ? theme.colors.primary : theme.colors.background};
  ${({
  disabled
}) => disabled && 'opacity: 50%;'};
  ${({
  disabled
}) => disabled ? '' : 'cursor: pointer;'};
  border-radius: 3px;
  border: ${({
  theme
}) => theme.border.border};
  width: ${({
  theme
}) => theme.size.md};
  height: ${({
  theme
}) => theme.size.md};
`;
export { Checkbox as default };
//# sourceMappingURL=CheckBox.js.map
